// Menu Drawer Overlay Click Handler
document.addEventListener('DOMContentLoaded', function() {
  const menuDrawerOverlay = document.querySelector('.menu-drawer__overlay');
  
  if (menuDrawerOverlay) {
    // Add click event listener to the overlay
    menuDrawerOverlay.addEventListener('click', function(e) {
      // Prevent the click from bubbling up to other elements
      e.stopPropagation();
      
      // Close the menu drawer by clicking the menu toggle button
      const menuToggle = document.querySelector('.header__icon--menu');
      if (menuToggle) {
        menuToggle.click();
      }
    });
  }
}); 